import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import SvgIcon from "../../../../../parts/SvgIcon";

const VARIANT = {
  info: { icon: "/img/new-icons/vuesax-linear-activity.svg", mod: "np-insights__row--info" },
  warn: { icon: "/img/new-icons/warning-white.svg",           mod: "np-insights__row--warn" },
  good: { icon: "/img/new-icons/check-bold.svg",              mod: "np-insights__row--good" },
};

export const InsightsPanel = ({ insights }) => {
  const { t } = useTranslation("athlete-portal");
  if (!insights.length) return null;
  return (
    <div className="np-insights">
      <div className="np-insights__header">
        <SvgIcon
          src="/img/new-icons/lightbulb.svg"
          useCurrentColor
          classNames="np-insights__header-icon"
        />
        <span className="np-insights__title">{t("nutritionPage.progress.insights.title")}</span>
        <span className="np-insights__subtitle">{t("nutritionPage.progress.insights.subtitle")}</span>
      </div>

      <div className="flex flex-col gap-2">
        {insights.map((insight) => {
          const v = VARIANT[insight.variant] ?? VARIANT.info;
          return (
            <div
              key={insight.text.slice(0, 40)}
              className={`np-insights__row ${v.mod}`}
            >
              <SvgIcon
                src={insight.icon ?? v.icon}
                useCurrentColor
                classNames="np-insights__row-icon"
              />
              <p className="np-insights__row-text">{insight.text}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

InsightsPanel.propTypes = {
  insights: PropTypes.arrayOf(
    PropTypes.shape({
      priority: PropTypes.number,
      variant: PropTypes.string,
      text: PropTypes.string,
    })
  ).isRequired,
};
